const OptGroup = () => null;
OptGroup.isSelectOptGroup = true;
export default OptGroup;
